// The program value-props, shown as a clean vertical benefit list in the
// landing hero's left rail. Content is driven by portal_settings (value_props),
// so the copy and icons can be rebranded per region without code changes.
// Icons resolve through the curated icon registry. Presentational only.
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { selectSettings } from '../../store/settings-slice.js';
import { resolveValuePropIcon } from '../../config/icon-registry.js';

const ValuePropStrip = () => {
  const settings = useSelector(selectSettings);
  const valueProps = settings.value_props || [];

  return (
    <Box
      component="ul"
      aria-label="Program benefits"
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      {valueProps.map(({
        key, icon, title, body,
      }) => {
        const Icon = resolveValuePropIcon(icon);
        return (
          <Box component="li" key={key} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box
              aria-hidden="true"
              sx={{
                flexShrink: 0,
                width: 44,
                height: 44,
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
                color: 'primary.main',
              }}
            >
              <Icon fontSize="small" />
            </Box>
            <Box>
              <Typography component="h3" variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
                {title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {body}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ValuePropStrip;
